
import axios,{buildApi} from "@/libs/api.request";

export const apis = buildApi({
	get:['/common/country'],
})
// 获取列表
export const getCountry = function(params) {
  return axios.request({
    url: '/common/country',
    params,
    method: 'get'
  })
}


// 创建列表
export const addCountry = (data) => {
  return axios.request({
    url: '/common/country',
    data,
    method: 'post'
  })
}
// 获取详情
export const getDetails = (id) => {
  return axios.request({
    url: `/common/country/${id}`,
    method: 'GET'
  })
}
// 更新列表
export const updateCountry = (data) => {
  return axios.request({
    url: `/common/country/${data.id}`,
    method: 'put',
    data
  })
}

// 删除列表
export const deleteCountry = (id) => {
  return axios.request({
    url: `/common/country/${id}`,
    method: 'DELETE'
  })
}

export const getCountryCity = (id, type = 'cityName', airwayNumber= '') => {
  return axios.request({
    url: `/common/country/city?id=${id}&type=${type}&airwayNumber=${airwayNumber}`,
    method: 'GET'
  })
}
